<template>
  <b-card class="mb-0">
    <div slot="header">{{ $dt('employees.form.title','Employee Form') }}</div>
    <div v-if="spinners.contentIsLoading" class="text-center">
      <b-spinner type="grow" variant="primary" />
    </div>
    <div v-else>
      <b-form-group disabled>
        <label>{{ $dt('employees.form.displayName', 'Name') }}</label>
        <b-form-input type="text" v-model="entity.displayName" />
      </b-form-group>
      <b-form-group disabled>
        <label>{{ $dt('employees.form.email', 'Email') }}</label>
        <b-form-input type="text" v-model="entity.email" />
      </b-form-group>
      <b-form-group :invalid-feedback="fErr('workload')">
        <label>{{ $dt('employees.form.workload', 'Workload') }}</label>
        <b-form-input type="number" :class="{ 'is-invalid': fErr('workload') }" v-model="entity.workload" />
      </b-form-group>

      <b-form-group disabled>
        <b-form-checkbox v-model="entity.active">
          {{ $dt('employees.form.active','Active') }}
        </b-form-checkbox>
      </b-form-group>
      <b-form-group :invalid-feedback="fErr('enabled')">
        <b-form-checkbox :class="{ 'is-invalid': fErr('enabled') }" v-model="entity.enabled">
          {{ $dt('employees.form.enabled','Enabled') }}
        </b-form-checkbox>
      </b-form-group>
      <b-form-group :invalid-feedback="fErr('plannable')">
        <b-form-checkbox :class="{ 'is-invalid': fErr('plannable') }" v-model="entity.plannable">
          {{ $dt('employees.form.plannable','Plannable') }}
        </b-form-checkbox>
      </b-form-group>
      <b-form-group :invalid-feedback="fErr('plan_internal')">
        <b-form-checkbox :class="{ 'is-invalid': fErr('plan_internal') }" v-model="entity.plan_internal">
          {{ $dt('employees.form.plan_internal','Int. proj.') }}
        </b-form-checkbox>
      </b-form-group>
      <b-form-group :invalid-feedback="fErr('rate_worklogs')">
        <b-form-checkbox :class="{ 'is-invalid': fErr('rate_worklogs') }" v-model="entity.rate_worklogs">
          {{ $dt('employees.form.rate_worklogs','Workl. top') }}
        </b-form-checkbox>
      </b-form-group>

    </div>
    <div slot="footer">
      <b-button type="submit" variant="primary" :disabled="spinners.isSaving" @click="save()">
        <b-spinner v-if="spinners.isSaving" type="grow" small />
        {{ $t('global.save') }}
      </b-button>
      <!-- <b-button :to="{ name: 'EmployeesNew' }" variant="info" class="ml-2">{{ $dt('global.cancel-back', 'Cancel/Back') }}</b-button> -->
      <!-- <b-button @click="$router.back()" variant="info" class="ml-2">{{ $dt('global.cancel-back', 'Cancel/Back') }}</b-button> -->
    </div>
  </b-card>
</template>

<script>
import merge from 'lodash.merge';
import Services from '@/services/index';
import VT from '@/store/types';
// import { mapGetters, mapActions } from 'vuex';

export default {
  mounted() {
    this.load();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: false,
        isSaving: false,
      },
      entity: this.value,
      errorMsg: this.errors,
    };
  },
  props: {
    // If id === null, form will be considered create form else update
    id: { type: Number, default: null },
    // if title == false to hide header, pass string to override default title
    title: { type: [String, Boolean], default: undefined },
    // pass errors from parent form if embedded
    errors: { type: Object, default() { return {}; } },
    // value is used both as DEFAULTs placeholder and for v-model
    value: {
      type: Object,
      default() {
        return {
          enabled: false,
          plannable: false,
          plan_internal: false,
          rate_worklogs: false,
        };
      },
    },
  },
  components: {
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
  },
  methods: {
    load() {
      this.spinners.contentIsLoading = true;
      Services.jira.employeeEdit({ id: this.id }).then(({ data }) => {
        this.spinners.contentIsLoading = false;
        this.entity = data.entity;
      }).catch((data) => {
        this.spinners.contentIsLoading = false;
        this.errorMsg = data.data ? data.data.errors : {};
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;
      Services.jira.employeeUpdate({ data: this.entity }).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        // this.entity = data.data; // This wont work if entity has nested objects/forms
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
      }).catch((data) => {
        this.spinners.isSaving = false;
        this.errorMsg = data.errors || {};
      });
    },
  }
};
</script>

<style scoped>

</style>
